import React from 'react';

const Badge = ({ children, color = '#4cbb4c' }) => (
  <span style={{
    display: 'inline-block', padding: '4px 14px', borderRadius: 20,
    fontSize: 12, fontWeight: 700, letterSpacing: 1.2, textTransform: 'uppercase',
    background: `${color}18`, color, border: `1px solid ${color}44`, marginBottom: 16
  }}>{children}</span>
);

export default Badge;
